import { useTheme } from 'styled-components';

import { useCommon } from '../../context/CommonContext';
import { CustomersWithCustomElementsE } from '../../declarations/enums/common';
import Spinner from '../Spinner/Spinner';
import { ButtonStyled, IconWrapStyled } from './Button.styled';

export type BaseButtonPropsT = {
  modifier?: 'primary' | 'secondary' | 'muralto' | 'counter' | 'inline' | 'link' | string;
  isRounded?: boolean;
  isFullWidth?: boolean;
  isFullHeight?: boolean;
  type?: 'submit' | 'button' | 'reset';
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isLoading?: boolean;
  isInverted?: boolean;
  isUpperCase?: boolean;
  icon?: string | React.ReactNode;
};

const Button: React.FC<BaseButtonPropsT> = ({
  modifier,
  isFullWidth,
  isFullHeight,
  children,
  isLoading,
  isInverted,
  disabled,
  isRounded = true,
  isUpperCase = true,
  type = 'button',
  icon,
  ...props
}) => {
  const { name } = useTheme();
  const { slugUrl } = useCommon();
  const hasIcon = Boolean(icon);

  const isNotRounded = [
    CustomersWithCustomElementsE.ILHA_DE_TOQUE_ECO_BOTIQUE_HOTEL_SAO_SEBASTIAO,
    CustomersWithCustomElementsE.MURAL_TO,
    CustomersWithCustomElementsE.SIX_SENSES_DOURO_VALLEY_SAMODAES,
  ].includes(slugUrl as CustomersWithCustomElementsE);

  return (
    <ButtonStyled
      type={type}
      modifier={modifier || name.toLowerCase()}
      isInverted={isInverted}
      isUpperCase={isUpperCase}
      isFullWidth={isFullWidth}
      isFullHeight={isFullHeight}
      isLoading={isLoading}
      isRounded={isRounded && !isNotRounded}
      disabled={disabled || isLoading}
      icon={icon}
      {...props}
    >
      {hasIcon && <IconWrapStyled>{icon}</IconWrapStyled>}

      {isLoading ? <Spinner /> : children}
    </ButtonStyled>
  );
};

export default Button;
